import { BaseDto } from "@/shared/dtos/base-dto";

export class controller_api extends BaseDto {
  public Controller!: string;
  public Action!: string;
  public HttpMethod!: string;
  public RouteTemplate!: string;
}
